module.exports = __webpack_public_path__ + "assets/img/view.8da3797a.png";